import { memo } from "react";

export interface BlankLayoutProps {
  children: React.ReactNode;
}

// 404页面
export default memo(({ children }: BlankLayoutProps) => <>{children}</>);
